import React from 'react';
import PropTypes from 'prop-types';
import Image from '@components/image';

import styles from './styles.module.scss';
const {
  header,
  step_three,
  property_images_container,
  footer,
  property_images,
  property_image,
  previous_step
} = styles;

const StepThree = (props) => {
  let { nextStepCallback, address, zip, photos, state, city } = props;

  // -------------------------------------------------------
  const firstThreeImages = photos?.slice(0, 3);
  // -------------------------------------------------------

  return (
    <>
      <div className={step_three}>
        <div className={header}>
          <h2>Request Submitted</h2>
        </div>
        <div className={property_images_container}>
          <div className={property_images}>
            {firstThreeImages.map((photo, i) => {
              return (
                <div className={property_image} key={i}>
                  <Image
                    image={{ height: '125px', src: photo.midSizeImageUrl, width: '150px' }}
                    alt={photo.title}
                  />
                </div>
              );
            })}
          </div>
          <p>
            {address}
            <br />
            {city}, {state} {zip}
          </p>
        </div>
        <div className={footer}>
          <p>Thank you! We'll be in touch with you shortly.</p>
          <button
            type="button"
            className={previous_step}
            onClick={(e) => {
              e.preventDefault();
              nextStepCallback(2);
            }}
          >
            &#60; Return to property details
          </button>
        </div>
      </div>
    </>
  );
};

StepThree.propTypes = {
  /**
   * Specifies the listing address
   */
  address: PropTypes.string,

  /**
   * Specifies the listing address city
   */
  city: PropTypes.string,

  /**
   * Callback func that tracks the next step click
   */
  nextStepCallback: PropTypes.func,

  /**
   * Specifies the listing address property photos
   */
  photos: PropTypes.array,

  /**
   * Specifies the listing address state
   */
  state: PropTypes.string,

  /**
   * Specifies the listing address zip code
   */
  zip: PropTypes.string
};

export default StepThree;
